/**
 * 
 * 
 * 方法接受两个参数 
 *  查询对象
 *  是否开启loading
 */

import urls from './urls'
import { message } from 'antd'

const API = {}
let fetchTimer = null

for (let k in urls) {//eslint-disable-line
  API[k] = (query = {}, hasLoading = false, returnResult = false) => {
    return fetcher(urls[k], query, hasLoading, returnResult)
  }
}

const fetcher = (urlObj, query, hasLoading, returnResult) => {
  if (typeof query === 'boolean') {
    hasLoading = query
    query = {}
  }
  let params = global.$deviceId ? {...query, deviceId: global.$deviceId} : {...query}
  const headers = new Headers()
  const config = {
    method: urlObj.method || 'GET',
    credentials: 'include',
    headers: headers
  }

  let url = urlObj.url

  const customHeaders = urlObj.headers || {}
  for(let hName in customHeaders){
    headers.append(hName, customHeaders[hName])
  }


  if (urlObj.method.toUpperCase() === 'POST') {
    headers.append('Content-Type', 'application/json')
    const { getQuery } = params
    if (getQuery) {
      url += url.indexOf('?') === -1 ? '?' : '&'
      for (let k in getQuery) {
        const val = getQuery[k] === undefined ? '' : getQuery[k]
        url += `${encodeURIComponent(k)}=${encodeURIComponent(val)}&`
      }
      url = url.slice(0, -1)
    }
    delete params.getQuery
    config.body = JSON.stringify(params)
  }
  else if (params) {
    url += url.indexOf('?') === -1 ? '?' : '&'
    for (let k in params) {//eslint-disable-line
      const val = params[k] === undefined ? '' : params[k]
      url += `${encodeURIComponent(k)}=${encodeURIComponent(val)}&`
    }
    url = url.slice(0, -1)
  }
  // 添加token
  const token = localStorage.getItem('token') 
  if (token) {
    headers.append('token', token)
  }

  const globalLoading = document.querySelector('.global-loading')
  const canUseLoading = hasLoading && globalLoading

  canUseLoading && globalLoading.classList.add('show')

  return fetch(url, config)
    .then(response => response.json())
    .then(result => {
      canUseLoading && globalLoading.classList.remove('show')
      if (+result.code === 0) {
        if (returnResult) {
          return result
        } else {
          return result.data || result.msg
        }
      }
      if (+result.code === 372163) {
        setTimeout(() => window.location = '/', 1500)
      }
      if (+result.code === 1002) {
        setTimeout(() => window.location = '/index', 1500)
      }
      if (+result.code === 1001) {
        localStorage.removeItem('token')
        setTimeout(() => window.location = '/', 1500)
      }
      if (+result.code === 2001) { // 2001表示同步金蝶时弹窗
        return result
      }
      return Promise.reject(result)
    })
    .catch(err => {
      canUseLoading && globalLoading.classList.remove('show')
      if(err.code === 1001 || err.code === 1002 || !err.code){//1001表示登录失效1002表示没有访问权限 防止弹多次窗////500的时候接口异常也在这里处理,500的时候err中没有code
        if(!fetchTimer)message.error( err.msg || '服务器发生错误，请联系管理员')
        clearTimeout(fetchTimer)
        fetchTimer = setTimeout(() => {
          fetchTimer = null
        }, 1000)
      }else{
        message.error( err.msg || '服务器发生错误，请联系管理员')
      }
      return Promise.reject(err || { msg: '服务器发生错误，请联系管理员' })
    })
}

export default API